import React, { useState } from "react";
import { BiSolidReport } from "react-icons/bi";
import { MdChevronRight } from "react-icons/md";
import Card from "../../../components/card";
import EntryHourReport from "./components/EntryHourReportModal";

const Reports: React.FC = () => {
  const [openEntryHourReportModal, setOpenEntryHourReportModal] =
    useState<boolean>(false);

  return (
    <div className="mt-5 flex flex-col gap-5 animate-fade-up">
      {/* Cabeçalho da página */}
      <div className="flex items-center gap-4">
        <span className="dv-aura flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-dv-gradient text-white shadow-dv-glow">
          <BiSolidReport className="h-6 w-6" aria-hidden="true" />
        </span>
        <div className="min-w-0">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-dv-blue-500/10 px-3 py-1 font-display text-xs font-bold uppercase tracking-[0.18em] text-dv-blue-600 dark:text-dv-cyan-300">
            Relatórios
          </span>
          <h1 className="mt-1.5 text-2xl font-extrabold tracking-tight text-navy-700 dark:text-white">
            Central de Relatórios
          </h1>
        </div>
      </div>

      <Card extra="p-5">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <button
            type="button"
            onClick={() => setOpenEntryHourReportModal(true)}
            className="group relative flex items-start gap-4 overflow-hidden rounded-2xl border border-gray-100 bg-white p-4 text-left transition-all duration-200 hover:-translate-y-0.5 hover:border-dv-blue-200 hover:shadow-dv-md active:scale-[.98] dark:border-white/10 dark:bg-navy-900 dark:hover:border-dv-cyan-400/40"
          >
            <span
              className="pointer-events-none absolute -right-8 -top-10 h-24 w-24 rounded-full bg-dv-blue-500/10 opacity-0 blur-2xl transition-opacity duration-300 group-hover:opacity-100"
              aria-hidden="true"
            />
            <span className="dv-aura flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-dv-gradient text-white shadow-dv-glow">
              <BiSolidReport className="h-6 w-6" aria-hidden="true" />
            </span>
            <div className="relative min-w-0 flex-1">
              <div className="flex items-center justify-between gap-2">
                <p className="font-bold text-navy-700 dark:text-white">
                  Relatório de Apontamentos
                </p>
                <MdChevronRight
                  className="h-5 w-5 shrink-0 text-gray-400 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:text-dv-blue-500 dark:group-hover:text-dv-cyan-300"
                  aria-hidden="true"
                />
              </div>
              <p className="mt-1 text-sm text-gray-700 dark:text-gray-300">
                Um resumo das horas apontadas pela sua equipe.
              </p>
            </div>
          </button>
        </div>
      </Card>

      <EntryHourReport
        openEntryHourReportModal={openEntryHourReportModal}
        setOpenEntryHourReportModal={setOpenEntryHourReportModal}
      ></EntryHourReport>
    </div>
  );
};

export default Reports;
